var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"content"},[_c('div',{staticClass:"img-ui",class:{smallImg:_vm.smallImg}},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }